import React from 'react';
import { TableRow, TableCell, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/system';

function PhysicianRow({ physician, selectedItemId, viewMode = 'standard' }) {
    const theme = useTheme();

    const getStatusChipProperties = (value) => {
        switch (value) {
        case 'submitted':
            return { label: 'Reviewed', color: theme.palette.blue.main }; // Blue
        case 'in-progress':
            return { label: 'In Progress', color: theme.palette.yellow.inProgress }; // Yellow
        case 'open':
            return { label: 'Not Reviewed', color: theme.palette.hold.main }; // Grey
        case 'inaccessible':
            return { label: '- Not Engaged -', isPlainText: true };
        default:
            return { label: '', color: '' };
        }
    }

    // Get chip properties (label and color) for any value
    const getVoteLabels = (value) => {
        switch (value) {
        case 4:
            return { label: 'Always (>95%)' }; 
        case 3:
            return { label: 'Often (50-95%)' };
        case 2:
            return { label: 'Rarely (20-50%)' };
        case 1:
            return { label: 'Never (<20%)' };
        default:
            return { label: 'No Vote', color: theme.palette.subtext.main };
        }
    };

    const item_vote = selectedItemId ? physician.item_reviews?.[selectedItemId] : null;
    const reviewStatusProps = getStatusChipProperties(physician.review_status);
    const itemVoteProps = getVoteLabels(item_vote);

    return (
        <TableRow 
            sx={{ 
                backgroundColor: physician.review_status === 'inaccessible' ? theme.palette.grey[100] : 'inherit',
                opacity: physician.review_status === 'inaccessible' ? 0.6 : 1
            }} 
        >
            <TableCell>Dr. {physician.last_name}</TableCell>
            <TableCell>{physician.specialty}</TableCell>
            <TableCell sx={{ textAlign: 'center' }}>{(physician.pack_usage * 100).toFixed(viewMode === 'standard' ? 2 : 0)}%</TableCell>
            <TableCell>
                {reviewStatusProps.isPlainText ? (
                    <Typography fontSize="14px">{reviewStatusProps.label}</Typography>
                ) : (
                    <Chip 
                        label={reviewStatusProps.label} 
                        sx={{ backgroundColor: reviewStatusProps.color, color: 'white' }}
                        size="small"
                    />
                )}
            </TableCell>
            <TableCell>
                <Typography color={itemVoteProps.color} fontSize="14px">{selectedItemId ? itemVoteProps.label : ''}</Typography>
            </TableCell>
        </TableRow>
    );
}

export default PhysicianRow;